import { render, staticRenderFns } from "./ScoreDetail.vue?vue&type=template&id=2fdf8aa0&scoped=true&"
import script from "./ScoreDetail.vue?vue&type=script&lang=js&"
export * from "./ScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDetail.vue?vue&type=style&index=0&id=2fdf8aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf8aa0",
  null
  
)

export default component.exports